import React from 'react';
import PropTypes from 'prop-types';
import MultipleChoiceQuestion from '../components/MultipleChoiceQuestion';

const answerOptions = [
  {id: 1, label: 'Me'},
  {id: 2, label: 'Someone I care for'},
  {id: 3, label: 'My Client'},
];

const ParticipantTypeQuestion = ({data, handleAnswer}) => {
  return (
    <MultipleChoiceQuestion
      question="Who is this request for?"
      item="participant_type"
      data={data}
      answerOptions={answerOptions}
      handleAnswer={handleAnswer}
    />
  );
};

ParticipantTypeQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ParticipantTypeQuestion;
